const EbComsConfig = () =>
  import(
    /* webpackChunkName: "ebComs_config" */
    "./Config"
  );

export default EbComsConfig;